import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Text} from '@optimaxdev/design-system';
import {Icon, PackagesMini} from '@optimaxdev/icons';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import {TYP_ORDER_CONFIRMATION} from 'constants/analytics/events/typ';

import {getOrderTrackingToken} from '../../store/selectors/orderLast/orderLast';

import s from './orderTracking.scss';

/**
 * Order tracking link
 */
export const OrderTracking = () => {
    const orderTrackingToken = useSelector(getOrderTrackingToken);

    const sendAnalytics = () => {
        sendDesktopAnalyticsEvent(
            TYP_ORDER_CONFIRMATION,
            {
                label: 'Order Tracking',
            },
            true,
        );
    };

    return (
        <div className={s.orderInfo}>
            <Icon className={s.orderTrackingIcon} color={Colors.limedSpruce} icon={PackagesMini} />
            <Link
                onClick={sendAnalytics}
                rel="noopener noreferrer"
                target="_blank"
                to={`/tracking/search/?token=${orderTrackingToken}`}
            >
                <Text color={Colors.limedSpruce} lineHeight="24px" size="16px" underline>
                    Track your order
                </Text>
            </Link>
        </div>
    );
};
